<template>
  <div>
    <BlockTitle title="资产分类" />
    <div id="categoryChartDom" class="chart-canvas" />
  </div>
</template>

<script>
import BlockTitle from '@/views/public_0983cc/tradeData/components/public/BlockTitle.vue'
import DataItem from './components/DataItem.vue'
import { mapGetters } from 'vuex'
import * as echarts from 'echarts'

export default {
  components: {
    BlockTitle,
    DataItem
  },
  data() {
    return {
      chartInstance: null,
      chartData: []
    }
  },
  computed: {
    ...mapGetters(['statisData', 'selectLocId']),
    chartDom() {
      return document.getElementById('categoryChartDom')
    },
    charOption() {
      const data = [
        { name: '专业机械设备', value: 106 },
        { name: '井、坑', value: 5 },
        { name: '交通运输和水利设施用地', value: 1930 },
        { name: '仓储用房', value: 13 },
        { name: '仓库', value: 20 },
        { name: '住宅', value: 2158 },
        { name: '体育、娱乐用房', value: 99 },
        { name: '停车场', value: 2 },
        { name: '公共管理与公共服务用地', value: 1324 },
        { name: '其他仓储用房', value: 5 },
        { name: '其他农用地', value: 3918 },
        { name: '其他办公用房', value: 38 },
        { name: '其他办公设备', value: 3 },
        { name: '其他商业及服务业用房', value: 105 },
        { name: '其他场', value: 3 },
        { name: '其他居住用房', value: 3 },
        { name: '其他工业生产用房', value: 4 },
        { name: '其他建设用地', value: 19 },
        { name: '其他房屋建筑', value: 2285 },
        { name: '其他机器、设备', value: 1773 },
        { name: '其他生产用房', value: 42 },
        { name: '其他经营性固定资产', value: 399 },
        { name: '其他资源性资产', value: 8 },
        { name: '其他长期投资', value: 68 },
        { name: '其他非经营性固定资产', value: 6725 },
        { name: '其他非经营性资产', value: 66 },
        { name: '其他非经营生物资产', value: 210 },
        { name: '养殖场', value: 2 },
        { name: '养殖水面（坑塘水面）', value: 728 },
        { name: '农业生产用房', value: 26 },
        { name: '农业用塔', value: 10 },
        { name: '农业用槽', value: 10 },
        { name: '农村宅基地', value: 4 },
        { name: '农田水利设施用地（沟渠）', value: 1030 },
        { name: '办公楼', value: 59 },
        { name: '办公设备', value: 10019 },
        { name: '厂房', value: 33 },
        { name: '台、站', value: 25 },
        { name: '商服用地', value: 412 },
        { name: '商铺', value: 1027 },
        { name: '园地', value: 674 },
        { name: '图书、档案', value: 29 },
        { name: '场', value: 51 },
        { name: '坝、堰及水道', value: 132 },
        { name: '宿舍', value: 2 },
        { name: '工矿仓储用地', value: 305 },
        { name: '市场', value: 77 },
        { name: '廊', value: 4 },
        { name: '文艺、体育、娱乐设施', value: 498 },
        { name: '服务用房', value: 359 },
        { name: '未利用地', value: 9 },
        { name: '林地', value: 5010 },
        { name: '林木资产', value: 248 },
        { name: '桥梁、架', value: 44 },
        { name: '水上交通运输设备', value: 8 },
        { name: '水利管道', value: 225 },
        { name: '池、罐', value: 34 },
        { name: '洞', value: 4 },
        { name: '牲畜（禽）资产', value: 1 },
        { name: '生活用电器', value: 1014 },
        { name: '短期投资', value: 7 },
        { name: '码头', value: 2 },
        { name: '罩棚', value: 62 },
        { name: '耕地', value: 61480 },
        { name: '草地', value: 325 },
        { name: '行政单位用房', value: 454 },
        { name: '设施大棚', value: 2 },
        { name: '资源资质', value: 1 },
        { name: '车辆', value: 64 },
        { name: '道路', value: 575 },
        { name: '长期投资', value: 501 },
        { name: '闸', value: 1 }
      ]
      return {
        tooltip: {
          show: true
        },
        grid: {
        },
        series: [
          {
            type: 'wordCloud',
            sizeRange: [10, 23],
            rotationRange: [0, 0],
            textPadding: 0,
            autoSize: {
              enable: true,
              minSize: 15
            },
            textStyle: {
              fontFamily: 'sans-serif',
              color: function() {
                const color = [
                  '#27D38A',
                  '#FFCA1C',
                  '#5DD1FA',
                  '#F88E25',
                  '#47A0FF',
                  '#FD6565'
                ]
                const num = Math.floor(Math.random() * (5 + 1))
                return color[num]
              }
            },
            emphasis: {
              focus: 'self',
              textStyle: {
                textShadowBlur: 0,
                textShadowColor: '#333'
              }
            },
            width: '95%',
            height: '85%',
            data: data
          }
        ]
      }
    }
  },
  watch: {},
  async mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.chartDom)
      this.chartInstance.setOption(this.charOption)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-canvas {
  width: 100%;
  height: 220px;
}
</style>
